import React from 'react';
import { useDispatch } from 'react-redux';
import {
    auth as authAction,
    login as loginAction,
    logout as logoutAction,
} from '@zmedia/bm-soccer-ui/redux/actions/auth';

export interface UseAuthReturn {
    auth: () => void;
    login: () => void;
    logout: () => void;
}

function useAuth(): UseAuthReturn {
    const dispatch = useDispatch();

    const auth = React.useCallback(() => {
        dispatch(authAction());
    }, [dispatch]);

    const login = React.useCallback(() => {
        dispatch(loginAction());
    }, [dispatch]);

    const logout = React.useCallback(() => {
        dispatch(logoutAction());
    }, [dispatch]);

    return {
        auth,
        login,
        logout,
    };
}

export default useAuth;
